jQuery(document).ready(function($){
    

    $('.faq-question').click(function(){
        $(this).closest('.single-faq').find('.faq-answer').slideToggle();

        var arrow_icon = $(this).closest('.single-faq').find('.arrow-icon');

        if (arrow_icon.hasClass('fa-angle-down')){
            arrow_icon.removeClass('fa-angle-down');
            arrow_icon.addClass('fa-angle-up');
        }
        else{
            arrow_icon.removeClass('fa-angle-up');
            arrow_icon.addClass('fa-angle-down');
        }
    })

});